import icon from '../../assets/svg/客户管理.svg';
import type { RouteConfig } from '@/types/route';

export const routeConfig: RouteConfig = {
    title: 'route.customerManagement',
    icon:  <img src={icon} alt="Customer Management" className="w-4 h-4" />,
    layout: true,
    sort: 2
};